import { createContext, use } from "react";
import { DrawerContextType } from "./types";

export const DrawerContext = createContext<DrawerContextType | null>(null);

export const useDrawerContext = () => {
  const context = use(DrawerContext);

  if (!context) {
    throw new Error("useDrawerContext must be used within a Drawer");
  }

  return context;
};
